<template>
  <div>
    <div class="d-md-none mx--5">
      <BaseAccordion
        :items="tabs"
        @change-current-tab="changeCurrentTab"
      >
        <template v-slot:header="{item}">
          <fa-icon :icon="item.icon" /> {{ item.label }}
        </template>
        <slot />
      </BaseAccordion>
    </div>
    <div class="d-none d-md-block ">
      <base-tabs
        v-slot:default="{tab}"
        class="tabs"
        :current-tab="currentTab"
        :tabs="tabs"
        :disabled="disabled"
        @change-current-tab="changeCurrentTab"
      >
        <fa-icon :icon="tab.icon" /> {{ tab.label }}
      </base-tabs>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
    name: 'AccordionOrTabs',
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        currentTab: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        changeCurrentTab(tab) {
            this.$emit('change-current-tab', tab);
        },
    },
};
</script>
<style lang="scss">
.tabs a{
  font-size: 0.8rem;
}
</style>
